import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import TextInput from '../inputs/text-input'
import PhoneInputWrapper from '../inputs/phone-input'
import FlashAlert from '../../flash-alert'

function PersonForm(props) {
  const { alert, person, isLoading } = props
  const { register, reset, handleSubmit, setValue, formState: { errors }  } = useForm({})

  const [countryCode, setCountryCode] = useState()

  useEffect(() => {
    props.verify && props.verify(() => handleSubmit(onSubmit))
    reset(person)
  }, [])

  const onSubmit = (data) => {
    if (countryCode) data['country_code'] = countryCode
    props.verifyPerson({person: data})
  }

  const requiredMsg = 'Is required'

  return <form className={isLoading ? 'isLoading' : ''} onSubmit={handleSubmit(onSubmit)}>
    { isLoading && <div className='animated-spinner'></div> }
    { alert &&
      <div className='row'>
        <div className='col-xs-12'>
          <FlashAlert text={alert.text} type={alert.type} onHide={() => props.setAlert(null)} />
        </div>
      </div>
    }
    <div className='row'>
      <div className='col-xs-12 col-md-5'>
        <TextInput
          {...register('first_name', { required: requiredMsg })}
          label='First Name'
          mandatory='true'
          error={errors.first_name}
          onChange={(e) => setValue('first_name', e.target.value)}
        />
      </div>
      <div className='col-xs-12 col-md-5'>
        <TextInput
          {...register('last_name', { required: requiredMsg })}
          label='Last Name'
          mandatory='true'
          error={errors.last_name}
          onChange={(e) => setValue('last_name', e.target.value)}
        />
      </div>
    </div>
    <div className='row'>
      <div className='col-xs-12 col-md-5'>
        <PhoneInputWrapper
          {...register('phone', {required: requiredMsg})}
          label='Phone'
          mandatory='true'
          error={errors.phone}
          defaultValue={person.phone}
          onChange={(p, c) => {
            setCountryCode(c)
            setValue('phone', p)
          }}
        />
      </div>
      <div className='col-xs-12 col-md-5'>
        <TextInput
          {...register('email', {
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'invalid email address'
            } 
          })}
          label='Email'
          error={errors.email}
          onChange={(e) => setValue('email', e.target.value)}
        />
      </div>
    </div>
    <div className='person__warning'>We will send you a text verification code</div>
    <div className='navigation-buttons desktop-only'>
      <button className='btn btn-next' type='submit'>Verify</button>
      <button className='btn btn-back' onClick={(e) => {e.preventDefault(); props.onPrevStep()}}>Back</button>
    </div>
  </form>
}

PersonForm.propTypes = {
  alert: PropTypes.object,
  person: PropTypes.object.isRequired,
  verify: PropTypes.func.isRequired,
  verifyPerson: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setAlert: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func.isRequired,
}

export default PersonForm
